import { Typography } from "@mui/material";
import { KVCardRow } from "./CardContent";

export default function PlaybookCardContent({ node }) {
  const inputs = Object.keys(node.data.inputs).map((param) => {
    return (
      <Typography variant="body2" color={"#b5b5b5"}>
        <b>{param}</b>
      </Typography>
    );
  });

  return (
    <div>
      <KVCardRow
        label="Playbook Name"
        value={node.data.playbookName}
      ></KVCardRow>
      <KVCardRow
        label="Repository"
        value={node.data.playbookRepoName}
      ></KVCardRow>
      <KVCardRow
        label="Synchronous?"
        value={node.data.synchronous ? "yes" : "no"}
      ></KVCardRow>
      <KVCardRow
        label="Inputs"
        value={inputs.length > 0 ? inputs : "none"}
      ></KVCardRow>
    </div>
  );
}
